import React from 'react';
import PropTypes from 'prop-types';

import './PropertyDetailBasicInfo.css';

import { PropertyPhoto } from './PropertyPhoto/PropertyPhoto';
import { PropertyInfo } from './PropertyInfo/PropertyInfo';
import { PropertyOrgLogoAndName } from './PropertyOrgLogoAndName/PropertyOrgLogoAndName';
import { EconomicDevelopmentContacts } from './EconomicDevelopmentContacts/EconomicDevelopmentContacts';
import { BrokerRealtorContacts } from './BrokerRealtorContacts/BrokerRealtorContacts';

export function PropertyDetailBasicInfoComponent({
  type,
  org,
  basicInfo,
  contacts,
  additionalDetails,
  attach,
  id,
  showSlideshow,
  dateModified,
  viewer,
  displayKeys,
}) {
  return (
    <div>
      <PropertyPhoto
        type={type}
        attach={attach}
        id={id}
        showSlideshow={showSlideshow}
      />
      <PropertyInfo
        type={type}
        additionalDetails={additionalDetails}
        basicInfo={basicInfo}
        dateModified={dateModified}
        displayKeys={displayKeys}
      />
      <PropertyOrgLogoAndName org={org} />

      <EconomicDevelopmentContacts
        contacts={contacts}
        viewer={viewer}
      />

      <BrokerRealtorContacts
        contacts={contacts}
        viewer={viewer}
      />
    </div>
  );
}

// ToDo: Create a building proptype and import
PropertyDetailBasicInfoComponent.propTypes = {
  type: PropTypes.string.isRequired,
  org: PropTypes.object,
  additionalDetails: PropTypes.object.isRequired,
  basicInfo: PropTypes.object.isRequired,
  contacts: PropTypes.object.isRequired,
  attach: PropTypes.object,
  id: PropTypes.string,
  showSlideshow: PropTypes.func,
  dateModified: PropTypes.string,
  viewer: PropTypes.object.isRequired,
  displayKeys: PropTypes.arrayOf(PropTypes.string),
};

export default PropertyDetailBasicInfoComponent;



// WEBPACK FOOTER //
// ./src/components/PropertyDetail/PropertyDetailBasicInfo/PropertyDetailBasicInfo.js